import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetopanchganicabbooking() {



  const cardData =
  {
    keyword: 'Pune to Panchgani Cab Booking',
    heading: 'Sai Trupti Cabs: Pune to Panchgani Cab Booking',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune to Panchgani cab booking services, designed to make your scenic getaway smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors and ample luggage space for your hill-station-bound journey. Every trip is driven by a professional, background-verified chauffeur who ensures punctual pickup in Pune, courteous service, and safe, smooth driving all the way to Panchgani. With transparent one-way fares, flexible booking options (one-way or round-trip), and 24×7 customer support, Sai Trupti Cabs makes your travel from Pune to Panchgani convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Panchgani with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Table Land",
    "description": "Table Land is the crown jewel of Panchgani — a vast laterite plateau and the second-highest in Asia. Spanning over 6 km, it offers breathtaking panoramic views of valleys, hills, and the Krishna River winding below. The flat, grassy expanse is perfect for horse riding, paragliding, and watching sunsets that paint the sky in fiery hues. During the monsoon, it transforms into a mist-covered meadow, while in winter, the cool breeze adds magic to its charm. From adventure to photography, Table Land defines the grandeur of Panchgani’s natural beauty."
  },
  {
    "title": "Sydney Point",
    "description": "Sydney Point is one of Panchgani’s most popular viewpoints, offering sweeping views of the Dhom Dam backwaters and the Krishna Valley. Named after Sir Sidney Beckwarth, this viewpoint captures the lush green hills and shimmering waters that make Panchgani unforgettable. The short trek to the top is refreshing and ideal for morning walks or photography sessions. Visitors can relax under shaded gazebos, feeling the cool breeze and listening to birdsong. The peaceful atmosphere and spectacular scenery make Sydney Point a must-visit for nature lovers and couples alike."
  },
  {
    "title": "Parsi Point",
    "description": "Parsi Point is a scenic hilltop viewpoint that overlooks the tranquil Krishna Valley and the shimmering Dhom Dam. Its name originates from the Parsi community, who once favored this spot for relaxation and picnics. Today, it continues to be a favorite for families and tourists seeking stunning panoramic views. The surrounding landscape, dotted with forests and farmlands, looks especially beautiful at sunrise and sunset. The viewpoint also has small snack stalls and play areas for kids, making it a perfect blend of leisure and natural beauty."
  },
  {
    "title": "Devrai Art Village",
    "description": "Devrai Art Village is a creative sanctuary that bridges tribal artistry and modern design. Founded to support local artisans, it showcases intricate metal, stone, and bamboo craftwork inspired by nature and spirituality. Visitors can explore workshops, meet artists, and even purchase handmade souvenirs like lamps, sculptures, and jewelry. The serene environment, surrounded by trees and art installations, offers an inspiring glimpse into sustainable craftsmanship. Devrai Art Village is more than a tourist attraction — it’s a soulful experience that celebrates art, culture, and community in the heart of Panchgani."
  },
  {
    "title": "Mapro Garden",
    "description": "Mapro Garden is a must-visit attraction located between Panchgani and Mahabaleshwar, famous for its fresh strawberry products and family-friendly ambiance. The garden features a café serving iconic strawberry cream, milkshakes, and sandwiches, alongside a factory where visitors can watch jams and crushes being made. Beautifully landscaped lawns, fountains, and selfie spots make it perfect for a leisurely outing. During the annual Strawberry Festival, the garden comes alive with music, food stalls, and vibrant celebrations. Mapro Garden blends nature, flavor, and fun — making it one of Panchgani’s sweetest experiences."
  },
  {
    "title": "Lingmala Waterfall",
    "description": "Lingmala Waterfall, located just a short drive from Panchgani, cascades gracefully from a height of 600 feet, surrounded by lush forests. The sight of water plunging into a deep valley creates a mesmerizing view, especially during the monsoon. A small trek leads visitors through greenery to the upper and lower viewing points, offering perfect photo opportunities. The cool mist, chirping birds, and sound of gushing water add a sense of calm. Lingmala Waterfall is the perfect nature escape for those seeking refreshment and beauty away from the crowd."
  },
  {
    "title": "Harrison’s Folly",
    "description": "Harrison’s Folly is a flat plateau offering 360-degree panoramic views of Panchgani’s valleys and nearby villages. The spot is often called the ‘Mini Table Land’ and provides excellent vantage points for photography and sightseeing. Adventure lovers can enjoy ziplining and ATV rides across the plateau, while families can relax and watch the sunset. On clear days, you can even spot the distant peaks of Mahabaleshwar. The calm wind and scenic horizon make Harrison’s Folly one of Panchgani’s most underrated yet enchanting attractions."
  },
  {
    "title": "Rajpuri Caves",
    "description": "Rajpuri Caves are an ancient cluster of natural rock formations believed to have been used by the Pandavas during their exile. Surrounded by ponds filled with holy water, the caves hold immense mythological and religious importance. Devotees visit the small temple of Lord Kartikeya located inside the caves, while adventurers explore the narrow stone passages and mystical ambiance. The constant sound of dripping water and flickering diyas create a tranquil, sacred experience. Rajpuri Caves perfectly combine spirituality, mythology, and exploration — offering a glimpse into Panchgani’s ancient heritage."
  },
  {
    "title": "Dhom Dam Lake",
    "description": "Dhom Dam, located about 20 km from Panchgani, is a stunning reservoir on the Krishna River surrounded by hills and greenery. The calm waters and scenic backdrop make it ideal for boating, jet skiing, and photography. The reflection of the sky and hills on the lake’s surface creates a mirror-like effect that’s especially beautiful at dawn and dusk. Many travelers visit Dhom Dam for picnics and serene drives along its banks. It’s a peaceful escape that showcases the natural balance between water, wind, and wilderness in the Panchgani region."
  },
  {
    "title": "Wai Temples and Riverfront",
    "description": "Just below Panchgani lies the historic town of Wai, often called ‘Dakshin Kashi’ for its cluster of beautiful ghats and temples along the Krishna River. The Dholya Ganpati Temple, with its massive idol and stone architecture, draws pilgrims year-round. The ghats come alive during aarti as lamps reflect on the river’s calm waters. Wai also serves as a gateway to Panchgani and Mahabaleshwar, making it a popular cultural stop for travelers. The town’s peaceful riverfront, historic aura, and spiritual charm make it an unmissable part of any Panchgani itinerary."
  }
],



"services": [
  {
    "name": "Pune to Panchgani Cab Booking",
    "description": "Book a reliable cab from Pune to Panchgani with options including AC and non-AC vehicles, professional drivers, luggage assistance, and flexible pickup and drop points. Ideal for family trips, weekend getaways, and group travel, ensuring a comfortable and safe journey with transparent fares."
  },
  {
    "name": "Pune to Panchgani Taxi Service",
    "description": "Premium taxi service from Pune to Panchgani with well-maintained vehicles, experienced drivers, luggage support, and AC/non-AC options. Perfect for long-distance travel, sightseeing trips, and leisure travel with hassle-free online booking and transparent pricing."
  },
  {
    "name": "Pune to Panchgani Car Hire",
    "description": "Hire cars from Pune to Panchgani for outstation travel with a range of vehicles including sedans, SUVs, Innova, and Ertiga. Includes professional drivers, luggage support, flexible schedules, AC/non-AC options, and secure online booking for a smooth travel experience."
  },
  {
    "name": "Pune to Panchgani AC Cab",
    "description": "Comfortable AC cab service from Pune to Panchgani with professional drivers, luggage assistance, flexible pickup and drop points, and online booking. Ideal for family trips, corporate travel, and long-distance leisure trips ensuring a cool and relaxing ride."
  },
  {
    "name": "Pune to Panchgani Non AC Cab",
    "description": "Budget-friendly non-AC cab service from Pune to Panchgani with reliable vehicles, professional drivers, luggage support, and flexible scheduling. Perfect for travelers seeking economical yet safe and comfortable outstation transportation."
  },
  {
    "name": "Luxury Cab Pune to Panchgani",
    "description": "Premium luxury cab service from Pune to Panchgani with top-class vehicles, AC service, professional chauffeurs, luggage assistance, and timely pickups. Ideal for weddings, VIP travel, and corporate trips, ensuring a luxurious and comfortable journey."
  },
  {
    "name": "Pune to Panchgani Innova Cab",
    "description": "Spacious Innova cab from Pune to Panchgani with seating for 6-7 passengers, AC/non-AC options, professional drivers, luggage support, flexible pickup/drop points, and transparent fares. Perfect for family trips, group outings, and corporate travel."
  },
  {
    "name": "Pune to Panchgani Ertiga Cab",
    "description": "Comfortable Ertiga cab service from Pune to Panchgani with AC/non-AC options, professional drivers, luggage assistance, and flexible pickup/drop locations. Ideal for small families, group trips, and long-distance leisure travel with safe and reliable service."
  },
  {
    "name": "Affordable Pune to Panchgani Cab",
    "description": "Budget-friendly cab service from Pune to Panchgani offering AC/non-AC options, professional drivers, luggage support, flexible pickup/drop points, and transparent fares. Perfect for travelers seeking cost-effective yet comfortable and reliable transportation."
  },
  {
    "name": "Pune to Panchgani Outstation Cab",
    "description": "Outstation cab service from Pune to Panchgani with AC/non-AC vehicles, professional drivers, luggage assistance, flexible schedules, and secure online booking. Ideal for weekend trips, leisure travel, and long-distance journeys with safe and reliable service."
  },
  {
    "name": "Pune to Panchgani One Way Cab",
    "description": "Convenient one-way cab service from Pune to Panchgani with AC/non-AC options, professional drivers, luggage support, and transparent fares. Perfect for travelers who need a one-way drop without worrying about return journeys."
  },
  {
    "name": "Pune to Panchgani Drop Cab",
    "description": "Drop cab service from Pune to Panchgani with AC/non-AC vehicles, professional drivers, luggage assistance, and flexible scheduling. Ensures safe, comfortable, and timely travel to your destination with transparent pricing."
  },
  {
    "name": "Pune to Panchgani Corporate Cab",
    "description": "Corporate cab service from Pune to Panchgani with AC/non-AC vehicles, professional chauffeurs, luggage support, flexible pickup/drop points, and online booking. Ideal for business trips, corporate events, and client travel ensuring comfort and punctuality."
  },
  {
    "name": "Pune to Panchgani Wedding Cab",
    "description": "Premium wedding cab service from Pune to Panchgani with luxurious vehicles, AC/non-AC options, professional drivers, luggage assistance, and timely pickups. Perfect for transporting family, guests, and VIPs to wedding venues safely and comfortably."
  },
  {
    "name": "Pune to Panchgani Online Booking",
    "description": "Book your Pune to Panchgani cab online instantly with secure payments, multiple AC/non-AC vehicle options, professional drivers, luggage support, and flexible pickup/drop points. Convenient for planning trips in advance or on short notice."
  }
],
"tableData": [
  ["Pune to Panchgani Cab Booking", "Pune to Panchgani Taxi Service"],
  ["Pune to Panchgani Car Hire", "Pune to Panchgani AC Cab"],
  ["Pune to Panchgani Non AC Cab", "Luxury Cab Pune to Panchgani"],
  ["Pune to Panchgani Innova Cab", "Pune to Panchgani Ertiga Cab"],
  ["Affordable Pune to Panchgani Cab", "Pune to Panchgani Outstation Cab"],
  ["Pune to Panchgani One Way Cab", "Pune to Panchgani Drop Cab"],
  ["Pune to Panchgani Corporate Cab", "Pune to Panchgani Wedding Cab"],
  ["Pune to Panchgani Online Booking", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Panchgani Cab Booking",
    "WhyChoosedescription": "Sai Trupti Cabs  offers reliable and comfortable cab services from Pune to Panchgani — ideal for weekend getaways, family trips, and leisure travel."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Get clear one-way fare estimates for Pune to Panchgani cabs, starting at affordable rates depending on vehicle type — no hidden charges or surprises."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, or premium cars to suit your group size, luggage, and comfort preferences for your Panchgani trip."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and skilled drivers are familiar with the Pune to Panchgani route, ensuring a safe, smooth, and timely journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We provide pickups from anywhere in Pune (city, airport, or suburbs) and drop-offs at any location in Panchgani, including hotels, resorts, or viewpoints."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All vehicles are regularly serviced, sanitized, and maintained to ensure comfort and reliability for your travel from Pune to Panchgani."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated team is available round-the-clock to assist with bookings, route planning, or any travel queries."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Panchgani cab easily via call, WhatsApp, or our website — with instant confirmation and prompt vehicle dispatch."
  }
]
















  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Pune to Panchgani cab services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable Pune to Panchgani cab services for one-way trips, round trips, and weekend getaways.',
  },
  {
    question: 'How can I book a Pune to Panchgani cab with Sai Trupti Cabs?',
    answer: 'You can easily book your Pune to Panchgani cab through our website, mobile app, or by contacting our 24×7 customer support team for instant booking and assistance.',
  },
  {
    question: 'What types of cabs are available from Pune to Panchgani?',
    answer: 'We offer hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers to suit your travel needs, group size, and budget.',
  },
  {
    question: 'Are the drivers experienced for Pune to Panchgani trips?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in hill-station driving, ensuring a safe and comfortable journey to Panchgani.',
  },
  {
    question: 'Can I hire a cab from Pune to Panchgani for sightseeing and local travel?',
    answer: 'Certainly. Our cab services can be customized to include sightseeing at major Panchgani attractions such as Table Land, Sydney Point, and Parsi Point.',
  },
  {
    question: 'Is the Pune to Panchgani cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab services for Pune to Panchgani travel to suit your convenience and schedule.',
  },
  {
    question: 'What are the Pune to Panchgani cab fares?',
    answer: 'Our Pune to Panchgani cab fares start from approximately ₹2,000 for sedans and ₹2,800–₹3,800 for SUVs or Innova Crysta, depending on vehicle type and travel duration.',
  },
  {
    question: 'What payment methods are accepted for Pune to Panchgani cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for a smooth and secure booking experience.',
  },
  {
    question: 'What safety and hygiene measures are followed for Pune to Panchgani cabs?',
    answer: 'All vehicles are thoroughly sanitized before each trip, and our drivers follow strict hygiene and safety measures to ensure a worry-free journey.',
  },
  {
    question: 'Is customer support available during the Pune to Panchgani cab ride?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your Pune to Panchgani trip for a hassle-free travel experience.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Kulkarni',
    feedback: 'I booked a Pune to Panchgani cab with Sai Trupti Cabs. The car was clean, and the driver was very professional and polite throughout the journey.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Shraddha Joshi',
    feedback: 'Excellent cab service from Pune to Panchgani. Smooth booking process, comfortable ride, and very friendly driver. Highly recommended!',
    rating: 5,
  },
];






















































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];















const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Panchgani Cab Booking",
  "image": "https://saitrupticabs.com/assets/images/pune-to-panchgani-cab.jpg",
  "description": "Book reliable cab services from Pune to Panchgani. Choose from AC, Non-AC, Innova, Ertiga, or luxury cabs for one-way trips, drop services, corporate travel, weddings, or family trips. Affordable online booking available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2500"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1200",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-panchgani-cab-booking"
  }
};



  return (
    <div>
      
<Helmet>
  <title>Pune to Panchgani Cab Booking | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book reliable cab services from Pune to Panchgani. Choose from AC, Non-AC, Innova, Ertiga, or luxury cabs for one-way trips, drop services, corporate travel, weddings, or family trips. Affordable online booking available 24x7." 
  />
  <meta 
    name="keywords" 
    content="Pune to Panchgani Cab Booking, Pune to Panchgani Taxi Service, Pune to Panchgani Car Hire, Pune to Panchgani AC Cab, Pune to Panchgani Non AC Cab, Luxury Cab Pune to Panchgani, Pune to Panchgani Innova Cab, Pune to Panchgani Ertiga Cab, Affordable Pune to Panchgani Cab, Pune to Panchgani Outstation Cab, Pune to Panchgani One Way Cab, Pune to Panchgani Drop Cab, Pune to Panchgani Corporate Cab, Pune to Panchgani Wedding Cab, Pune to Panchgani Online Booking" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/42.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetopanchganicabbooking;